<template>
  <div class="editProfile">
    <h1 class="upload-user-image">
      <input
        ref="file"
        type="file"
        accept="image/*"
        class="van-uploader__input"
        @change="fileChange"
      />
      <img v-if="user.image" class="profile-img" :src="imgsrc(user.image)" />
      <span v-else>
        {{ $t("UPLOAD PROFILE PICTURE HERE") }}
      </span>
    </h1>
    <van-cell-group>
      <van-cell :title="$t('email')">
        <template #right-icon>
          {{ user.email }}
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group>
      <van-cell>
        <template #title>
          <label for="input-name">
            {{ $t("name") }}
          </label>
        </template>
        <template #right-icon>
          <input id="input-name" class="input-name" v-model="user.name" />
        </template>
      </van-cell>
    </van-cell-group>
    <div class="saveActions">
      <van-button type="primary" @click="submitSave">
        {{ $t("save") }}
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "EditProfile",
  computed: {
    ...mapState("account", ["user"])
  },
  data() {
    return {
      uploader: []
    };
  },
  methods: {
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    ...mapActions("account", [
      "logout",
      "uploadUserImage",
      "updateUserProfile"
    ]),
    fileChange() {
      const { $refs } = this;
      let formData = new FormData();
      formData.append("image_upload", $refs.file.files[0]);
      this.uploadUserImage(formData);
    },
    imgsrc(image) {
      return image
        ? `https://f002.backblazeb2.com/file/sprkr-user-uploads/${image}`
        : "";
    },
    submitSave() {
      this.updateUserProfile({
        name: this.user.name
      });
    }
  },
  created() {
    this.SET_PAGE_TITLE(this.$t("edit profile"));
  }
};
</script>

<style lang="scss">
.editProfile {
  .saveActions {
    display: flex;
    justify-content: flex-end;
    padding: 15px;
  }
}
.input-name {
  width: 75%;
  border: 0;
  text-align: right;
}
.upload-user-image {
  position: relative;
  .van-uploader__input {
    width: inherit;
    height: inherit;
  }
  border: 1px solid rgba(245, 245, 245, 0.1);
  background: rgba(245, 245, 245, 0.5);
  border-radius: 50%;
  height: 200px;
  width: 200px;
  display: flex;
  justify-self: center;
  align-self: center;
  justify-items: center;
  align-content: center;
  align-self: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  justify-self: center;
  margin: 10px auto;
  text-align: center;
  overflow: hidden;
  .profile-img {
    width: auto;
    height: 100%;
  }
}
</style>
